import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const HiddenMarketLoader: LoaderFnConfig = {
    id: 'hidden-market',
    loaderFn: () => import('./hidden-market.feature'),
    product: ClientConfigProductName.SPORTS,
};
